module.exports = __webpack_public_path__ + "static/media/whyChooseUs.a6c04961.jpg";